module.exports = __webpack_public_path__ + "media/landing-page/bg-hero-4-min-b1c93457.svg";